import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@elixir/components';
import {GetRequest} from '../../../common/service/GetRequest';
import {map} from 'lodash';
import {withRouter} from 'react-router-dom';
import classNames from 'classnames/bind';

import './headerNav.scss';

class HeaderNav extends React.Component {

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.state = {
            buttonList: []
        };
    }

    componentDidMount () {
        const requestUrl = '/rest/OperatorFunction/availableOperatorFunctions';

        new GetRequest(requestUrl).then(
            (result) => {
                const routingMap = {
                    userCenter: '/app/user',
                    preferences: '/app/preference'
                };

                const buttonList = map(result, (buttonId) => {
                    return {
                        id: buttonId,
                        i18n: 'headerNav.' + buttonId,
                        route: routingMap[ buttonId ]
                    };
                });

                this.setState({
                    buttonList: buttonList
                });

            }
        );
    }

    navigateToButton (route) {
        this.props.history.push(route);
    }

    getButtonClassList (activeRoute, buttonRoute) {
        const isActiveButton = buttonRoute.indexOf(activeRoute) !== -1 ? 'active' : '';
        return classNames('headerNavButton', isActiveButton);
    }

    render () {
        const buttonList = this.state.buttonList;
        const activeRoute = this.props.location.pathname;

        return (
            <div className="headerNav">

                {buttonList.map((button, index) => {
                    return <Button className={this.getButtonClassList(activeRoute, button.route)}
                                   key={button.id}
                                   name={button.id}
                                   type="primary"
                                   onClick={this.navigateToButton.bind(this, button.route)}>

                        <span>{this.context.translator(button.i18n)}</span>
                    </Button>;
                })}


            </div>
        );
    }
}

export default withRouter(HeaderNav);
